export enum UrlString {
	UNASSIGNED_VIEW = 'UnassignedView',
	ASSIGNED_VIEW = 'AssignedView',
	OPEN_VIEW = 'OpenView',
	COMPLETED_VIEW = 'CompletedView',
	ACTIVE_VIEW = 'ActiveView'
}
